module.exports = __webpack_public_path__ + "static/media/logo.9ef9fa08.png";